import { render, staticRenderFns } from "./backgroundDownload.vue?vue&type=template&id=bb0caa84&lang=pug&"
import script from "./backgroundDownload.vue?vue&type=script&lang=js&"
export * from "./backgroundDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports